// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1fM78","label":"styles_label__1JaUi"};